const searchFeedback = {
  starting:
    "Veuillez patienter quelques secondes pendant que nous cherchons les prix et disponibilités.",
  still_progress: "La recherche est toujours en cours…",
  noresult:
    "Aucun hôtel n'est disponible: vos critères sont peut-être trop restrictifs.",
  updating_map: "Mise à jour de la carte, veuillez patienter…",
  error:
    "Nous sommes confus, une erreur est survenue dans la recherche des prix. Veuillez réessayer en rechargeant la page.",
  error_page:
    "Nous sommes confus, une erreur est survenue dans la construction de cette page. Veuillez réessayer en rechargeant la page.",
  empty: "",
};

const transportKinds = {
  metro: "Métro",
  tram: "Tram",
  rer: "RER",
};

const Messages = {
  searchFeedback,
  transportKinds,
};

export default Messages;
